"use client";
import React from "react";
import { useFormikContext } from "formik";
import clsx from "clsx";
import AlertCircle from "atd-icons/dist/AlertCircle";

const InputField = ({
  type = "text",
  placeholder = "",
  label = "",
  name = "",
  onChange,
}) => {
  const formik = useFormikContext();

  const hasError =
    !!formik.errors?.[name] &&
    formik.values?.[name] !== formik?.initialValues?.[name];

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      formik.setFieldValue(name, e.target.value);
    }
  };

  return (
    <div className={"relative w-full"}>
      <div
        className={clsx({
          "absolute transition-all 0.3s ease text-[#B7BAC7] z-[5]": true,
          "text-[10px] top-[4px] bg-[#ffffff50] left-[16px]":
            formik.values?.[name],
          "text-base top-[14px] left-[16px]": !formik.values?.[name],
        })}
      >
        {label && (
          <label className={`block p-[2px]`} htmlFor={name}>
            {label}
          </label>
        )}
      </div>
      {type === "textarea" ? (
        <TextArea
          className={hasError ? "border-[#DC2626]" : ""}
          value={formik.values?.[name] || ""}
          type={type}
          name={name}
          id={name}
          onChange={handleChange}
          placeholder={placeholder}
          onBlur={(e) => formik.setFieldValue(name, e.target.value)}
        />
      ) : (
        <Input
          className={clsx({
            "border-[#DC2626]": hasError,
            "placeholder-[#667085] text-[16px]": true,
          })}
          value={formik.values?.[name] || ""}
          type={type}
          name={name}
          id={name}
          onChange={handleChange}
          placeholder={placeholder}
          onBlur={(e) => formik.setFieldValue(name, e.target.value)}
        />
      )}
      {formik.touched?.[name] && formik.errors?.[name] && (
        <div className="flex gap-[4px] items-center mt-[6px]">
          <AlertCircle color="#DC2626" size={16} />
          <p className="text-[13px] text-[#DC2626] font-medium">
            {formik.errors?.[name]}
          </p>
        </div>
      )}
    </div>
  );
};

export const Input = ({ className, type, ...props }) => {
  return (
    <input
      type={type}
      className={`bg-[#f9f9f9] text-[#434343] flex h-9 w-full rounded-md border border-input text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 py-[28px] px-[16px] ${className}`}
      {...props}
    />
  );
};

export const TextArea = ({ className, type, ...props }) => {
  return (
    <textarea
      className={`bg-[#f9f9f9] text-[#434343] flex w-full rounded-md border border-input text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 py-[16px] px-[16px] text-[16px] ${className}`}
      {...props}
      rows={5}
    />
  );
};

export default InputField;
